import * as React from "react";
import { url as gravatar } from "gravatar";
import { UserImageWrapper, FallbackWrapper } from "./user-circle-image-style";

interface Props {
    username: string;
    size: number;
    className?: string;
    email?: string;
    image?: string;
    color?: string | "accent";
}

// these colors are selected by doing a walk around LCH(59, 97, HUE)
const colorMap = [
    "#ff0092",
    "#ff0076",
    "#ff005a",
    "#ff1d3f",
    "#ff3c20",
    "#fd5200",
    "#ed6500",
    "#d97400",
    "#c48000",
    "#ad8b00",
    "#939400",
    "#769b00",
    "#54a100",
    "#1ba500",
    "#00a900",
    "#00ab2d",
    "#00ad4f",
    "#00af6e",
    "#00b08c",
    "#00b1a9",
    "#00b1c6",
    "#00b1e2",
    "#00b0fb",
    "#00aeff",
    "#00abff",
    "#00a7ff",
    "#00a2ff",
    "#009aff",
    "#0091ff",
    "#0085ff",
    "#7977ff",
    "#ae66ff",
    "#d452fd",
    "#f039e5",
    "#ff13ca",
    "#ff00ae",
];

export default class UserCircleImage extends React.Component<Props & React.HTMLAttributes<HTMLDivElement>> {
    public render(): React.ReactNode {
        let imageContent: React.ReactNode = null;
        const { className, email, size, username, color: cTmp, image, ...rest } = this.props;
        let color = cTmp;

        if (image !== undefined) {
            imageContent = <UserImageWrapper className={className} src={image} size={size} />;
        } else if (username.length === 0) {
            // we need to show the default icon
            const url = gravatar("nobody", { size: (size * 2).toString(), rating: "pg", default: "mp" });
            imageContent = <UserImageWrapper className={className} src={"https:" + url} size={size} />;
        } else if (email !== undefined) {
            if (color === undefined) {
                const hue = username
                    .split("")
                    .map(c => c.charCodeAt(0))
                    .reduce((prev, current) => (prev + current) % colorMap.length);

                color = colorMap[hue];
            }
            const fallback = (
                <FallbackWrapper fontSize={Math.floor(size * 0.6)} background={color}>
                    {username[0].toUpperCase()}
                </FallbackWrapper>
            );

            const url = gravatar(email, { size: (size * 2).toString(), rating: "pg", default: "404" });
            imageContent = (
                <UserImageWrapper
                    className={className}
                    src={"https:" + url}
                    size={size}
                    alternate={fallback}
                    altBehavior="both"
                    {...rest}
                />
            );
        }

        return imageContent;
    }
}
